import React, { useEffect } from 'react';
import MDBox from 'components/MDBox';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import { useForm } from 'react-hook-form';
import { GridForm } from 'components/Ui/styled';
import { PaperPropsWithoutScrollbar } from 'constants';
import { FormInputText } from 'components/Common/Forms/FormTextField';
import {
  getDialogHeading,
  dynamicDefaultValue,
  camelCaseToTitleCase,
} from 'utils/commonUtils';

const BookedSessionInfoDialog = (props) => {
  const {
    bookedSessionViewDialog,
    setBookedSessionViewDialog,
    bookedSessionInfo,
  } = props;

  const dynamicForm = dynamicDefaultValue(bookedSessionInfo);

  const { reset, control } = useForm({
    mode: 'onChange',
    defaultValues: dynamicForm,
  });

  useEffect(() => {
    if (bookedSessionViewDialog) {
      reset(dynamicForm);
    }
  }, [bookedSessionViewDialog, reset]);

  const handleClose = () => {
    setBookedSessionViewDialog(false);
  };

  const bookedSessionInfoFields = (dynamicForm, control) => {
    const textFields = [];

    const sensitiveFields = ['sessionId', 'timeSlotId', 'subjectId'];

    const renderFields = (data, parentKey = '') => {
      Object.entries(data).forEach(([key, value]) => {
        const fullKey = parentKey ? `${parentKey}.${key}` : key;
        const fieldType = sensitiveFields.includes(key) ? 'password' : 'text';

        if (value && typeof value === 'object' && !Array.isArray(value)) {
          renderFields(value, fullKey);
        } else {
          textFields.push(
            <Grid item xs={12} sm={6} key={fullKey}>
              <FormInputText
                name={fullKey}
                label={camelCaseToTitleCase(key)}
                control={control}
                readOnly
                type={fieldType}
              />
            </Grid>
          );
        }
      });
    };

    renderFields(dynamicForm);
    return { textFields };
  };

  const { textFields } = bookedSessionInfoFields(dynamicForm, control);

  return (
    <>
      <Dialog
        open={bookedSessionViewDialog}
        PaperProps={PaperPropsWithoutScrollbar}
      >
        {getDialogHeading('Report Execution', handleClose)}
        <GridForm container spacing={1}>
          {textFields}
        </GridForm>
        <MDBox mb={3} />
      </Dialog>
    </>
  );
};

export default BookedSessionInfoDialog;
